module.exports = __webpack_public_path__ + "img/hr-sand-decal-25.a899925b.png";